/**
 * Store Clients
 */
export default {
    state: {
        espaceProNon: 0,
        espaceProOui: 1,
        espaceProAttenteCrea: 2,
        espaceProAttenteCode: 3,
        espaceProAttenteSuppleant: 4,
    },
}
